import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, MenuItem, Select, Snackbar } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import {
  getProgramEnrollments,
  updateDeviceEnrollment,
} from '../../../actions/admin'

/**
 * Editable Yes/No cell for a boolean flag (`enrolled` or `ineligible`) on a
 * device enrollment row in the admin tool. A Save button appears only once the
 * selection differs from the record; saving PATCHes that one flag and
 * refreshes the enrollments table.
 */
export default function DeviceEnrollmentFlagCell({
  field,
  current,
  deviceType,
  enrollmentId,
  profileId,
}) {
  const dispatch = useDispatch()
  const [value, setValue] = useState(current)
  const [saving, setSaving] = useState(false)
  const [result, setResult] = useState(null)

  useEffect(() => {
    setValue(current)
  }, [current])

  const isDirty = value !== current

  const save = async () => {
    setSaving(true)
    const action = await dispatch(
      updateDeviceEnrollment(deviceType, enrollmentId, { [field]: value }),
    )
    if (action?.error) {
      setResult({
        severity: 'error',
        message:
          action.payload?.response?.detail ||
          'Failed to update the device enrollment.',
      })
    } else {
      setResult({ severity: 'success', message: 'Device enrollment updated.' })
      // Refresh before re-enabling the cell so the row reflects the new state
      await dispatch(getProgramEnrollments(profileId))
    }
    setSaving(false)
  }

  return (
    <>
      <Select
        value={value ? 'yes' : 'no'}
        onChange={(e) => setValue(e.target.value === 'yes')}
        disabled={saving}
      >
        <MenuItem value="yes">Yes</MenuItem>
        <MenuItem value="no">No</MenuItem>
      </Select>
      {isDirty && (
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={save}
          disabled={saving}
          style={{ marginLeft: 8 }}
        >
          {saving ? 'Saving…' : 'Save'}
        </Button>
      )}
      <Snackbar
        open={!!result}
        autoHideDuration={6000}
        onClose={() => setResult(null)}
      >
        <Alert severity={result?.severity} onClose={() => setResult(null)}>
          {result?.message}
        </Alert>
      </Snackbar>
    </>
  )
}
